import { Offering } from '@arrived/models';

import { canOfferingStatusReserveShares } from './canOfferingStatusReserveShares';
import { isRemainingSharesLessThanMinimumActionableShares } from './isRemainingSharesLessThanMinimumActionableShares';

export const calculateRemainingShares = (offering: Offering) => {
  const { status, totalShares, totalSharesReserved, totalSharesTransacted } = offering;

  if (isRemainingSharesLessThanMinimumActionableShares(offering)) {
    return 0;
  }

  return totalShares - (canOfferingStatusReserveShares(status) ? totalSharesReserved : totalSharesTransacted);
};
